export const CREATE_ZONE_MODAL_KEY = 'CreateZone'
